module.exports = __webpack_public_path__ + "fonts/ropa-sans-v9-latin-ext_latin-italic.woff?b02e6000a78d692fe6513f6d9f5b6e18";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ropa-sans-v9-latin-ext_latin-italic.woff
// module id = 313
// module chunks = 0